<template>
  <div class="navbar">
    <dinapsis-navbar
      :menu.prop="menu"
      :heightToolbar.prop="77"
      :keycloak.prop="KeycloakInstance()"
      @click-menu="menuClicked($event)"
    ></dinapsis-navbar>
  </div>
</template>
<script>
import * as AuthService from '@/services/AuthService.js';
import * as RolService from '@/services/RolService.js';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      isSuperAdmin: 'PF/isSuperAdmin',
      isAdmin: 'PF/isAdmin',
      isAdminEntidad: 'PF/isAdminEntidad',
      isExternal: 'PF/isExternal',
      haveEntidadesVisiblesRelated: 'PF/haveEntidadesVisiblesRelated',
      isDeliveryUser: 'PF/isDeliveryUser'
    })
  },
  async created () {
    await this._getMenu();
    this.selectedItemMenu();
  },
  mounted () {
    this.observeMenuIsOpen();
  },
  beforeDestroy () {
    if (this.observer) this.observer.disconnect();
  },
  data () {
    return {
      menu: [],
      isOpen: false
    };
  },
  methods: {
    KeycloakInstance () {
      return AuthService.KeycloakInstance();
    },
    observeMenuIsOpen () {
      const targetNode = document.getElementById('main');

      if (targetNode) {
        this.observer = new MutationObserver((mutationsList) => {
          for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              const currentlyOpened = targetNode.classList.contains('dx-drawer-opened');

              if (currentlyOpened !== this.isOpen) {
                this.isOpen = currentlyOpened;
              }
            }
          }
        });

        const config = { attributes: true, attributeFilter: ['class'] };
        this.observer.observe(targetNode, config);
      }
    },
    async _getMenu () {
      await RolService.getEntidadesVisiblesRelated();

      if (this.isSuperAdmin) {
        this.menu = [
          {
            id: 'catalogo',
            text: 'Portfolio Dinapsis',
            icon: 'inbox',
            selected: false,
            children: []
          },
          {
            id: 'servicios',
            text: 'Gestión de servicios digitales',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'aplicaciones',
            text: 'Gestión de aplicaciones',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'ambitos',
            text: 'Gestión de ámbitos',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'tematicas',
            text: 'Gestión de temáticas',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'usuarios',
            text: 'Gestión de usuarios externos',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'verticales',
            text: 'Gestión de verticales',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'entidades',
            text: 'Gestión de entidades',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'autorizaciones',
            text: 'Gestión de autorizaciones',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'exportacion',
            text: 'Exportar datos',
            icon: 'send',
            selected: false,
            children: []
          }
        ];
      } else if (this.isAdmin && !this.isAdminEntidad && !this.isDeliveryUser) {
        this.menu = [
          {
            id: 'catalogo',
            text: 'Portfolio Dinapsis',
            icon: 'inbox',
            selected: false,
            children: []
          },
          {
            id: 'aplicaciones',
            text: 'Gestión de aplicaciones',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'usuarios',
            text: 'Gestión de usuarios externos',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'exportacion',
            text: 'Exportar datos',
            icon: 'send',
            selected: false,
            children: []
          }
        ];
        if (this.haveEntidadesVisiblesRelated) {
          const auth = {
            id: 'autorizaciones',
            text: 'Gestión de autorizaciones',
            icon: 'send',
            selected: false,
            children: []
          };
          this.menu.splice(3, 0, auth);
        }
      } else if (this.isAdmin && !this.isAdminEntidad && this.isDeliveryUser) {
        this.menu = [
          {
            id: 'catalogo',
            text: 'Portfolio Dinapsis',
            icon: 'inbox',
            selected: false,
            children: []
          },
          {
            id: 'aplicaciones',
            text: 'Gestión de aplicaciones',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'usuarios',
            text: 'Gestión de usuarios externos',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'autorizaciones',
            text: 'Gestión de autorizaciones',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'exportacion',
            text: 'Exportar datos',
            icon: 'send',
            selected: false,
            children: []
          }
        ];
      } else if (this.isAdmin && this.isAdminEntidad) {
        this.menu = [
          {
            id: 'catalogo',
            text: 'Portfolio Dinapsis',
            icon: 'inbox',
            selected: false,
            children: []
          },
          {
            id: 'aplicaciones',
            text: 'Gestión de aplicaciones',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'usuarios',
            text: 'Gestión de usuarios externos',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'entidades',
            text: 'Gestión de entidades',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'autorizaciones',
            text: 'Gestión de autorizaciones',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'exportacion',
            text: 'Exportar datos',
            icon: 'send',
            selected: false,
            children: []
          }
        ];
      } else if (this.isAdminEntidad && !this.isDeliveryUser) {
        this.menu = [
          {
            id: 'catalogo',
            text: 'Portfolio Dinapsis',
            icon: 'inbox',
            selected: false,
            children: []
          },
          {
            id: 'usuarios',
            text: 'Gestión de usuarios externos',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'entidades',
            text: 'Gestión de entidades',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'autorizaciones',
            text: 'Gestión de autorizaciones',
            icon: 'send',
            selected: false,
            children: []
          }
        ];
      } else if (this.isAdminEntidad && this.isDeliveryUser) {
        this.menu = [
          {
            id: 'catalogo',
            text: 'Portfolio Dinapsis',
            icon: 'inbox',
            selected: false,
            children: []
          },
          {
            id: 'aplicaciones',
            text: 'Gestión de aplicaciones',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'usuarios',
            text: 'Gestión de usuarios externos',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'entidades',
            text: 'Gestión de entidades',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'autorizaciones',
            text: 'Gestión de autorizaciones',
            icon: 'send',
            selected: false,
            children: []
          }
        ];
      } else if (this.isDeliveryUser) {
        this.menu = [
          {
            id: 'catalogo',
            text: 'Portfolio Dinapsis',
            icon: 'inbox',
            selected: false,
            children: []
          },
          {
            id: 'aplicaciones',
            text: 'Gestión de aplicaciones',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'usuarios',
            text: 'Gestión de usuarios externos',
            icon: 'send',
            selected: false,
            children: []
          },
          {
            id: 'autorizaciones',
            text: 'Gestión de autorizaciones',
            icon: 'send',
            selected: false,
            children: []
          }
        ];
      } else if (!this.isExternal || this.isExternal) {
        this.menu = [
          {
            id: 'catalogo',
            text: 'Portfolio Dinapsis',
            icon: 'inbox',
            selected: false,
            children: []
          }
        ];
        if (this.haveEntidadesVisiblesRelated) {
          const auth = {
            id: 'autorizaciones',
            text: 'Gestión de autorizaciones',
            icon: 'send',
            selected: false,
            children: []
          };
          this.menu.push(auth);
        }
      }

      const misServiciosDigitales = {
        id: 'serviciosDigitales',
        text: 'Mis Servicios Digitales',
        icon: 'send',
        selected: false,
        children: []
      };
      if (this.isSuperAdmin || this.haveEntidadesVisiblesRelated) {
        this.menu.splice(1, 0, misServiciosDigitales);
      }
    },
    menuClicked (e) {
      // Same route?
      if (this.$route.name === e.detail) return;
      // Check if exist route with this name
      if (!this.checkIfExistRoute(e.detail)) return;

      this.$router.push({ name: e.detail });
    },
    checkIfExistRoute (routeName) {
      const routeExist = this.$router.options.routes.some(route => {
        return route.name === routeName || (route.children && route.children.some(child => child.name === routeName));
      });

      if (!routeExist) {
        this.$router.push({ name: '404' });
        return false;
      }

      return true;
    },
    selectedItemMenu () {
      // Find item name inside menu to select by default
      const { name } = this.$route;
      if (!name) return;

      const item = this.searchRouteIntoMenu(name, this.menu);
      if (!item) return;

      // Select item
      item.selected = true;
    },

    searchRouteIntoMenu (nameToFind, menu) {
      for (let itemMenu of menu) {
        if (nameToFind === itemMenu.id) return itemMenu;
        if (itemMenu.children && itemMenu.children.length > 0) {
          return this.searchRouteIntoMenu(nameToFind, menu);
        }
      }
    }
  },
  watch: {
    isOpen: {
      handler: function () {
        // Set mutation
        this.$store.commit('PF/refreshToggleMenu', this.isOpen);
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss" scoped>
.navbar {
  &:deep() {
    .user-menu-closed {
      .user-name {
        height: 0;
      }
      .menu-user-btn {
        vertical-align: middle;
        position: relative;
        top: 3px;
      }
    }
  }
}
</style>
